export * from './Star';
//# sourceMappingURL=index.js.map